import axios from "axios";
import {API_URL} from "./config";
import { createSessionClient } from '../auth/sessionAPI';

const API = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    'Content-Type' : 'application/json',
  },
  withCredentials: true
})
const legacyAuthPost = API.post.bind(API)
const legacyAuthPaths = ['/login', '/signin', '/logout']

// The runtime binds legacy callers below; this factory remains isolated for
// explicit auth flows and never stores marker headers in Axios defaults.
export const createSessionAPI = (session, pageURL = window.location.href) =>
  createSessionClient(axios, {
    baseURL: API_URL||"http://localhost:4000",
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  }, session, pageURL)

// Legacy API modules import this singleton directly. Once the runtime is ready,
// forward those calls through the scoped client so redirect markers accompany
// protected requests without becoming Axios default headers.
export const bindSessionAPI = (session, pageURL = window.location.href) => {
  const client = createSessionAPI(session, pageURL)
  ;['get', 'delete', 'head', 'options'].forEach(method => {
    API[method] = (url, config) => client[method](url, config)
  })
  ;['post', 'put', 'patch'].forEach(method => {
    API[method] = (url, data, config) => {
      // Legacy auth exports remain usable for normal sessions. A redirect session
      // still cannot mutate here: it supplies no marker and the server rejects it.
      if (method === 'post' && legacyAuthPaths.includes(url) && !(config && config.attempt)) {
        return legacyAuthPost(url, data, config)
      }
      return client[method](url, data, config)
    }
  })
  API.request = config => client.request(config)
  return client
}

export default API
